import { Component, OnInit, forwardRef } from '@angular/core';
import { PhoneContact } from '@eceos/domain';
import { ControlValueAccessor, FormBuilder, FormGroup, FormArray, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-contact-phones-form',
  templateUrl: './contact-phones-form.component.html',
  styleUrls: ['./contact-phones-form.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ContactPhonesFormComponent),
      multi: true
    }
  ]
})
export class ContactPhonesFormComponent implements OnInit, ControlValueAccessor {
  private _value: PhoneContact[] = [];
  constructor() {}

  get value() {
    return this._value.filter(c => c.value && c.value !== '');
  }

  set value(value: PhoneContact[]) {
    if (value) {
      this._value = value;
    } else {
      this._value = [];
    }
  }

  get valueWithNew() {
    return this._value;
  }

  disabled = false;

  private onChangeListener: any = null;

  private onTouchedListener: any = null;

  ngOnInit() {}

  writeValue(obj: any): void {
    this.value = obj;
    this.assertEmptyValue();
  }

  registerOnChange(fn: any): void {
    this.onChangeListener = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedListener = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.assertEmptyValue();
  }

  onChange(value: string, contact: PhoneContact) {
    contact.value = value;
    this.assertEmptyValue();
    if (this.onChangeListener) {
      this.onChangeListener(this.value);
    }
  }

  remove(contact: PhoneContact) {
    this._value = this._value.filter(c => c !== contact);
    this.assertEmptyValue();
    if (this.onChangeListener) {
      this.onChangeListener(this.value);
    }
  }

  isValid(contact: PhoneContact) {
    return contact && contact.isValid;
  }

  private assertEmptyValue() {
    let invalidNumber = this._value.filter(c => !this.isValid(c)).length;
    if (invalidNumber > 1 || this.disabled) {
      this._value = this.value;
      invalidNumber = 0;
    }
    if (invalidNumber === 0 && !this.disabled) {
      this._value.push(new PhoneContact(''));
    }
  }
}
